import React, { Fragment } from "react";
import { useListContext, useRefresh, useUnselectAll } from "react-admin";
import VerifyMultipleBookingDialog from "./VerifyMultipleBookingDialog";

interface BookingBulkActionsProps {
  selectedIds?: number[];
}

const BookingBulkActions: React.FC<BookingBulkActionsProps> = ({
  selectedIds,
}) => {
  const refresh = useRefresh();
  const unselectAll = useUnselectAll("bookings");
  const listContext = useListContext();

  const statusFilter = listContext?.filterValues?.status;
  const hasSelection = selectedIds && selectedIds.length > 0;

  // Show verify button when there's selection and not filtering by non-verifiable status
  const nonVerifiableStatuses = ["new", "accepted", "cancelled"];
  const canVerify =
    hasSelection && !nonVerifiableStatuses.includes(statusFilter);

  const handleActionComplete = () => {
    refresh();
    unselectAll();
  };

  return (
    <Fragment>
      {canVerify && (
        <VerifyMultipleBookingDialog
          selectedIds={selectedIds || []}
          onComplete={handleActionComplete}
        />
      )}
    </Fragment>
  );
};

export default BookingBulkActions;
